import styled, { css } from 'styled-components'

type IsMobile = {
  isMobile: boolean
}

export const Container = styled.div<IsMobile>`
  margin-top: 7rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - 6rem);

  & > h4 {
    color: #898989;
  }
  
  & > h3 {
    margin-top: 0.5rem;
    text-align: center;
    line-height: 28px;
  }

  & > button {
    border-radius: 50px;
    width: 332px;
  }

  .secondaryButton {
    margin-top: 2rem;
    background-color: #FFFFFF !important;
    color: #1F35B5 !important;
    
    &:hover {
      background-color: #E7EAF8 !important;
    }
  }

  ${({ isMobile }) => isMobile && css`
    margin-top: 3rem;

    & > p {
      color: #898989;
    }

    & > h4 {
      margin-top: 0.5rem;
      color: inherit;
      max-width: 270px;
      text-align: center;
    }
  `}
`

export const DisclaimerWrapper = styled.div<IsMobile>`
  margin: 40px 0 54px;
  display: grid;
  grid-template-columns: 130px 470px;
  grid-template-rows: 68px 40px;
  grid-template-areas:
    "picture title"
    "picture content";
  gap: 20px;
  
  & img {
    grid-area: picture;
    width: 130px;
    height: 130px;
    border-radius: 50%;
  }

  > div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    > p {
      line-height: 20px;
    }

    .professionalRole {
      color: #898989;
    }
  }

  ${({ isMobile }) => isMobile && css`
    margin: 20px 0 30px;
    padding: 0 30px;
    grid-template-columns: 50px 240px;
    grid-template-rows: 104px 50px;
    grid-template-areas: 
      "title title"
      "picture content";
    gap: 15px;

    & > p {
      grid-area: title;
      text-align: left;
      line-height: 20px;
    }
    
    & > div {
      grid-area: content;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    & img {
      width: 50px;
      height: 50px;
    }
  `}
`